import React, { useState } from "react";

import "./ErrorDialog.scss";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import getStyles from "./getStyles";

const ErrorDialog = (props: {
  title?: string | null;
  error?: string | null;
  onClose?: () => void;
  action?: () => void;
}) => {
  const classes = getStyles();

  const [detailsVisible, setDetailsVisible] = useState<boolean>(false);

  return (
    <Dialog
      className="ErrorDialog-container"
      open={!!props.error}
      onClose={props.onClose}
    >
      <DialogTitle className={classes.titleBar}>
        An error has occured
      </DialogTitle>
      <DialogContent>
        <div className="ErrorDialog-reasonContainer">
          <ErrorOutlineIcon className="ErrorDialog-errorIcon" />
          <div className="ErrorDialog-reason">{props.title}</div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="ErrorDialog-doneButton"
          color="primary"
          autoFocus
          onClick={() => {
            if (props.action) {
              props.action();
            }

            if (props.onClose) {
              props.onClose();
            }
          }}
        >
          {props.action ? "Refresh" : "Done"}
        </Button>
        <Button
          className="ErrorDialog-showDetails"
          color="secondary"
          onClick={() => setDetailsVisible(detailsVisible => !detailsVisible)}
        >
          {detailsVisible ? (
            <>
              Hide details <ArrowDropUpIcon />
            </>
          ) : (
            <>
              Show details <ArrowDropDownIcon />
            </>
          )}
        </Button>
      </DialogActions>
      <DialogContent>
        {detailsVisible && (
          <div className="ErrorDialog-details">{props.error}</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
